import { Col, Row,Switch } from 'antd'

import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Communication from './Communication';
import ConstCommunication from './ConstCommunication';


const CommunicationBoth = (props) => {

    const [isOn, setIsOn] = useState(false);
    const routeLocation = useLocation();

    useEffect(() => {
        const view = new URLSearchParams(routeLocation.search).get('view');
        setIsOn(view === '2');
    }, [routeLocation.search]);

    return (
        <div>
            {/* <Row>
                <Col span={24}></Col>
                <Col span={24}>
                    <div className="d-flex justify-content-start align-items-center mt-2">
                        <Switch size="large" checked={isOn} checkedChildren="Content" unCheckedChildren="Communication" onChange={setIsOn} />
                    </div>
                </Col>
            </Row> */}
            <Row>
                <Col span={24}>
                  <div style={{ borderBottom: '1px solid #bfbfbf', paddingBottom:"13px", paddingTop:"13px", fontSize:"15px", fontWeight:"600"}}>
                    {!isOn ? "Communication" : "Content"}</div>
                    {!isOn ? (
                        <Communication isOn={isOn} setIsOn={setIsOn} />
                    ) : (
                        <ConstCommunication isOn={isOn} setIsOn={setIsOn} />
                    )}
                </Col>
            </Row>
        </div>
    );
}

export default CommunicationBoth;